import styled from 'styled-components';

export default styled.div`
  grid-area: date;
  align-self: center;
  justify-self: center;
`;
